/**
 * @fileoverview Input/output schemas for the plot-synopsis-extractor-v3 agent.
 *
 * This agent creates a condensed synopsis from imported content,
 * targeting approximately 3% of the original length with a minimum of 1000 tokens.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The full text content of the document to create a synopsis from.'),
  targetTokens: z.number().describe('The target number of tokens for the synopsis (calculated as 3% of input, minimum 1000).'),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

/**
 * Output schema for the plot-synopsis-extractor-v3 agent.
 * Returns a condensed synopsis of the input text.
 */
export const OutputSchema = z.object({
  synopsis: z.string().describe('A condensed synopsis capturing the essential plot, characters, themes, and narrative arc of the input text.'),
});

export type Output = z.infer<typeof OutputSchema>;
